import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import React from "react";

export const Person: React.FC<{
  image?: IGatsbyImageData | null;
  name?: string | null;
  jobTitle?: string | null;
  email?: string | null;
  phone?: string | null;
  description?: string | null;
}> = ({ image, name, jobTitle, email, phone, description }) => {
  return (
    <>
      {name && <h4 className="h4 pb-20px text-center">{name}</h4>}
      {image && (
        <div className="aspect-h-1 aspect-w-1">
          <GatsbyImage
            image={image}
            alt={name ?? "Individual"}
            style={{ position: "absolute" }}
            objectFit="contain"
            objectPosition="center"
            className="rounded-full"
            loading="lazy"
          />
        </div>
      )}
      {jobTitle && <h5 className="h5 pt-20px text-center">{jobTitle}</h5>}
      {description && <p className="p4 pt-10px text-center">{description}</p>}
      {email && (
        <a href={`mailto:${email}`} className="p4 pt-10px text-center">
          {email}
        </a>
      )}
      {phone && <p className="p4 text-center">tel: {phone}</p>}
    </>
  );
};
